import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { routes } from 'app/routes';
import { breakpoint } from 'app/theme/theme';

import { Footer } from './Footer';

interface LayoutProps {
  children: JSX.Element;
  header: JSX.Element;
}

const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ContentBackground = styled.div`
  flex-grow: 1;
  background: linear-gradient(90deg, #c6c6c6 0%, #fcfcfc 100%);
  padding: 1rem 0 2rem 0;

  ${breakpoint.up.md`
    padding: 1rem 0 4.5rem 0;
  `}
`;

const Content = styled.main<{ isForm?: boolean }>`
  margin: 0 0.5rem;
  min-height: 40vh;

  ${breakpoint.up.md`
    margin: 0 5rem;
  `}

  ${breakpoint.up.lg<{ isForm?: boolean }>`
    margin: 0 auto;
    max-width: ${({ isForm }) => (isForm ? '965px' : '1100px')};
  `}
`;

export const Layout = ({ children, header }: LayoutProps): JSX.Element => {
  const location = useLocation();

  const isForm =
    location.pathname.includes(routes.TRANSLATION_QUOTE.FORM) ||
    location.pathname.includes(routes.INTERPRETING_QUOTE) ||
    location.pathname.includes(routes.PROOFREADING_QUOTE) ||
    location.pathname.includes(routes.MULTILINGUALDTP_QUOTE) ||
    location.pathname.includes(routes.AUDIO_TRANSCRIPTION_QUOTE) ||
    location.pathname.includes(routes.COPYWRITING_QUOTE) ||
    location.pathname.includes(routes.SUBTITLING_QUOTE) ||
    location.pathname.includes(routes.VOICE_OVER_QUOTE);

  return (
    <PageWrapper>
      {header}
      <ContentBackground>
        <Content isForm={isForm}>{children}</Content>
      </ContentBackground>
      <Footer />
    </PageWrapper>
  );
};
